import { Button } from "src/elements";
import { useApi } from "src/api";
import { downloadFile } from "src/utils";
import { useState } from "react";

interface Props {
  categoryId: number;
  categoryCode: string;
  subCategory: string;
}

export const CdtOrderButton = ({ categoryId, categoryCode, subCategory }: Props) => {
  const { getCdtOrderApi } = useApi();
  const [isLoading, setIsLoading] = useState(false);

  const downloadCdtOrder = async () => {
    setIsLoading(true);
    const response = await getCdtOrderApi(categoryId);
    if (response) {
      const dateTime = new Date().toISOString().replace(/[:.]/g, "-");
      downloadFile({
        name: `cdt_order_${categoryCode}_${subCategory}_${dateTime}`,
        extension: "csv",
        data: response,
      });
    }
    setIsLoading(false);
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      size="small"
      dropdown={[
        {
          label: "CDT and Order",
          onClick: downloadCdtOrder,
          isLoading,
        },
      ]}
    >
      Download
    </Button>
  );
};
